import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonJa from './locales/ja/common.json';
import landingJa from './locales/ja/landing.json';
import timelineJa from './locales/ja/timeline.json';
import legalJa from './locales/ja/legal.json';
import commonEn from './locales/en/common.json';
import landingEn from './locales/en/landing.json';
import timelineEn from './locales/en/timeline.json';
import legalEn from './locales/en/legal.json';

const resources = {
  ja: {
    common: commonJa,
    landing: landingJa,
    timeline: timelineJa,
    legal: legalJa,
  },
  en: {
    common: commonEn,
    landing: landingEn,
    timeline: timelineEn,
    legal: legalEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS: 'common',
    ns: ['common', 'landing', 'timeline', 'legal'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18n_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
